//import { Zoom } from "@visx/zoom";
import ReactApexChart from "react-apexcharts";

//import { lineChartData, lineChartOptions } from "./variables/charts";

type Props = {
  graphData: any;
  refer?: any;
};

export const LineChart: any = ({ graphData, refer }: Props) => {
  if (graphData) {
    graphData[1].name = "Количество обращений";
    graphData[0].name = "Количество ошибок";
  }

  let lineChartData = graphData;

  let lineChartOptions: any = {
    chart: {
      height: 300,
      type: "area",
      toolbar: {
        show: refer == "single" ? false : true,
      },
      zoom: {
        enabled: refer == "single" ? false : true,
        allowMouseWheelZoom: false,
      },
    },

    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      //type: "datetime",
      categories: graphData && graphData[0]?.categories,
      tickAmount: 10,
      labels:
        refer !== "single"
          ? {
              style: {
                colors: "#c8cfca",
                fontSize: "12px",
              },
              formatter: function (value: any) {
                return value?.slice(10);
              },
            }
          : {
              style: {
                fontSize: "0px",
              },
            },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.5,
        gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
        inverseColors: true,
        opacityFrom: 0.8,
        opacityTo: 0,
        stops: [],
      },
      colors: ["#2D3748", "#d14f64"],
    },
    yaxis: [
      {
        stepSize: refer == "single" ? 1 : 0.5,
        title:
          refer !== "single"
            ? {
                text: "Количество отключений, %",
                style: {
                  fontWeight: 100,
                },
              }
            : {},
        labels:
          refer !== "single"
            ? {
                style: {
                  colors: "#c8cfca",
                  fontSize: "12px",
                },
              }
            : {
                style: {
                  fontSize: "0px",
                },
              },
      },
      {
        opposite: true,
        title:
          refer !== "single"
            ? {
                text: "Количество обращений",
                style: {
                  fontWeight: 100,
                },
              }
            : {},
        labels:
          refer !== "single"
            ? {
                style: {
                  colors: "#c8cfca",
                  fontSize: "12px",
                },
              }
            : {
                style: {
                  fontSize: "0px",
                },
              },
      },
    ],
    legend: {
      show: true,
    },

    colors: ["#2D3748", "#d14f64"],
  };

  return (
    <>
      {graphData && lineChartOptions && lineChartData && (
        <div
          id="chart"
          style={{ paddingLeft: 10, height: refer == "single" ? 150 : 300 }}
        >
          <ReactApexChart
            options={lineChartOptions}
            //series={graphData == "single" ? [lineChartData[0]] : lineChartData}
            series={lineChartData}
            type="area"
            height={"100%"}
          />
        </div>
      )}
    </>
  );
};
